import React, { useState, useEffect, useRef } from 'react';
import ProfileMenu from './ProfileMenu';
import NotificationPanel from './NotificationPanel';
import SocialInbox from './SocialInbox';

const API = 'https://talku.online';

const NAV_ITEMS = [
  { id:'Dashboard',      label:'Dashboard' },
  { id:'Conversaciones', label:'Conversaciones' },
  { id:'Pedidos',        label:'Pedidos' },
  { id:'Contactos',      label:'Contactos' },
  { id:'Flujos',         label:'Flujos' },
  { id:'Marketing',      label:'Marketing' },
];

const MK_TABS = ['Resumen', 'Páginas', 'Comentarios', 'Campañas', 'Inbox'];

/* ── Mock data ─────────────────────────────────────────── */
const PAGES_DATA = [
  { id:0, name:'Tiendas Colombia', handle:'@tiendascolombia', color:'#6ee7b7', followers:45200, flwDelta:340 },
  { id:1, name:'Trend Bird',       handle:'@trendbirdcol',    color:'#93c5fd', followers:12800, flwDelta:125 },
  { id:2, name:'Tokio Tienda',     handle:'@tokiotiendacol',  color:'#fcd34d', followers:8400,  flwDelta:78  },
];

const KPI_DATA = [
  { alcance:128400, alcD:12,  imp:342100, impD:8,   eng:4.2, engD:-0.3, seg:340, segD:22  },
  { alcance:38200,  alcD:5,   imp:94500,  impD:3,   eng:3.8, engD:0.4,  seg:125, segD:15  },
  { alcance:22100,  alcD:9,   imp:61400,  impD:7,   eng:3.1, engD:-0.1, seg:78,  segD:9   },
];

const CHART_DATA = [
  [{ d:'Lun',v:15200 },{ d:'Mar',v:18400 },{ d:'Mié',v:14800 },{ d:'Jue',v:21300 },{ d:'Vie',v:24100 },{ d:'Sáb',v:19200 },{ d:'Hoy',v:15400 }],
  [{ d:'Lun',v:4200  },{ d:'Mar',v:5100  },{ d:'Mié',v:4600  },{ d:'Jue',v:6200  },{ d:'Vie',v:7100  },{ d:'Sáb',v:5900  },{ d:'Hoy',v:5200  }],
  [{ d:'Lun',v:2800  },{ d:'Mar',v:3400  },{ d:'Mié',v:2900  },{ d:'Jue',v:4100  },{ d:'Vie',v:4800  },{ d:'Sáb',v:3600  },{ d:'Hoy',v:3000  }],
];

const POSTS_DATA = [
  [
    { id:1, type:'imagen',   caption:'Nueva colección — zapatillas de temporada con hasta 30% off. Envío gratis a todo Colombia.',  likes:892,  comments:64, reach:18400, shares:34, date:'May 3'  },
    { id:2, type:'carrusel', caption:'Nueva línea sport disponible en tallas 35 a 44. La zapatilla perfecta para el verano.',        likes:543,  comments:38, reach:12100, shares:18, date:'May 1'  },
    { id:3, type:'video',    caption:'Detrás de cámaras: así se hacen los mejores zapatos de Colombia. Proceso artesanal en Bogotá.',likes:1243, comments:89, reach:28400, shares:67, date:'Abr 25' },
    { id:4, type:'imagen',   caption:'Cliente feliz, nosotros felices. Gracias por compartir tu experiencia con nosotros.',          likes:341,  comments:22, reach:8900,  shares:9,  date:'Abr 29' },
    { id:5, type:'imagen',   caption:'ULTIMO DIA — 20% de descuento en toda la tienda. No lo dejes pasar.',                          likes:612,  comments:45, reach:14200, shares:28, date:'Abr 27' },
  ],
  [
    { id:6, type:'imagen',   caption:'New drop — Colección exclusiva ya disponible. Precios desde $89.000.',    likes:423, comments:31, reach:9800,  shares:14, date:'May 2'  },
    { id:7, type:'carrusel', caption:'Style inspo para esta semana. ¿Cuál es tu look favorito? Cuéntanos.',     likes:289, comments:18, reach:6400,  shares:8,  date:'Abr 30' },
    { id:8, type:'video',    caption:'Tendencias 2026 que no puedes perderte. Todo disponible en nuestra tienda.',likes:512, comments:42, reach:11200, shares:22, date:'Abr 28' },
  ],
  [
    { id:9,  type:'imagen', caption:'Estilo japonés, calidad colombiana. Nueva colección Tokio ya disponible.', likes:318, comments:24, reach:7200, shares:11, date:'May 1'  },
    { id:10, type:'imagen', caption:'Minimal, elegante, perfecto. Descubre nuestra línea urban. Envío a toda Colombia.', likes:201, comments:15, reach:4800, shares:6,  date:'Abr 28' },
  ],
];

const COMMENTS_INIT = [
  { id:1,  author:'Valentina M.', text:'¿Tienen envío a Medellín?',                                          post:'Nueva colección', page:'Tiendas Colombia', time:'Hace 5 min',   replied:false },
  { id:2,  author:'Santiago R.',  text:'Me llegó el pedido hoy y está hermoso, muchas gracias.',              post:'Cliente feliz',   page:'Tiendas Colombia', time:'Hace 12 min',  replied:true  },
  { id:3,  author:'Laura P.',     text:'¿Tienen talla 40 en el modelo café?',                                 post:'Nueva colección', page:'Tiendas Colombia', time:'Hace 28 min',  replied:false },
  { id:4,  author:'Camilo H.',    text:'El precio es excelente para la calidad que tienen.',                  post:'Último día 20%',  page:'Tiendas Colombia', time:'Hace 45 min',  replied:false },
  { id:5,  author:'Isabella C.',  text:'¿Aceptan pago contra entrega?',                                       post:'New drop',        page:'Trend Bird',       time:'Hace 1 hora',  replied:false },
  { id:6,  author:'Daniela V.',   text:'Los recibí ayer, súper puntuales y bien empacados.',                  post:'Estilo japonés',  page:'Tokio Tienda',     time:'Hace 2 horas', replied:true  },
  { id:7,  author:'Andrés F.',    text:'¿Cuánto tarda el envío a Cali?',                                      post:'Tendencias 2026', page:'Trend Bird',       time:'Hace 3 horas', replied:false },
  { id:8,  author:'Mariana L.',   text:'Ya hice mi pedido, espero que llegue pronto.',                        post:'Nueva colección', page:'Tiendas Colombia', time:'Hace 4 horas', replied:false },
  { id:9,  author:'Sebastián T.', text:'La calidad de los materiales es increíble, lo recomiendo al 100%.',  post:'Detrás de cámaras',page:'Tiendas Colombia',time:'Hace 5 horas', replied:true  },
  { id:10, author:'Natalia B.',   text:'¿Tienen plan de referidos? Me gustaría compartirlo con mis amigas.', post:'Style inspo',     page:'Trend Bird',       time:'Hace 6 horas', replied:false },
];

const CAMPAIGNS_DATA = [
  { id:1, name:'ASC Madres 2026',         status:'activa',    tienda:'Tiendas Colombia', budget:800000,  spent:324000, results:186,  metric:'Ventas',  cpa:1742, roas:4.2, pct:40  },
  { id:2, name:'ASC Temporada TCO',        status:'activa',    tienda:'Tiendas Colombia', budget:1500000, spent:890000, results:412,  metric:'Ventas',  cpa:2160, roas:3.8, pct:59  },
  { id:3, name:'Trend Bird — Awareness',   status:'pausada',   tienda:'Trend Bird',       budget:300000,  spent:180000, results:2400, metric:'Alcance', cpa:null, roas:null, pct:60  },
  { id:4, name:'Tokio — Lanzamiento',      status:'terminada', tienda:'Tokio Tienda',     budget:200000,  spent:200000, results:54,   metric:'Ventas',  cpa:3703, roas:2.1, pct:100 },
];

/* ── SVG icons ──────────────────────────────────────────── */
const IcoEye      = ({size=14,stroke='#9ca3af'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2" strokeLinecap="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>;
const IcoHeart    = ({size=14,stroke='#9ca3af'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2" strokeLinecap="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>;
const IcoMsg      = ({size=14,stroke='#9ca3af'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2" strokeLinecap="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>;
const IcoShare    = ({size=14,stroke='#9ca3af'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2" strokeLinecap="round"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>;
const IcoTrend    = ({size=14,stroke='#9ca3af'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2" strokeLinecap="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>;
const IcoUsers    = ({size=14,stroke='#9ca3af'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2" strokeLinecap="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/></svg>;
const IcoCheck    = ({size=12,stroke='#16a34a'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2.5" strokeLinecap="round"><polyline points="20 6 9 17 4 12"/></svg>;
const IcoArrowUp  = ({size=10,stroke='#16a34a'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2.5" strokeLinecap="round"><polyline points="18 15 12 9 6 15"/></svg>;
const IcoArrowDn  = ({size=10,stroke='#ef4444'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2.5" strokeLinecap="round"><polyline points="6 9 12 15 18 9"/></svg>;
const IcoImage    = ({size=22}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>;
const IcoCarousel = ({size=22}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>;
const IcoVideo    = ({size=22}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round"><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2"/></svg>;
const IcoSend     = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>;
const IcoSearch   = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#bbb" strokeWidth="2" strokeLinecap="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>;

const WaIcon = () => <svg width="11" height="11" viewBox="0 0 24 24" fill="#22c55e"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>;
const IgIcon = () => <svg width="11" height="11" viewBox="0 0 24 24" fill="none"><rect x="2" y="2" width="20" height="20" rx="5" fill="url(#igmk)"/><circle cx="12" cy="12" r="4.5" stroke="#fff" strokeWidth="1.5" fill="none"/><circle cx="17.5" cy="6.5" r="1" fill="#fff"/><defs><linearGradient id="igmk" x1="2" y1="22" x2="22" y2="2" gradientUnits="userSpaceOnUse"><stop stopColor="#f9ce34"/><stop offset="0.3" stopColor="#ee2a7b"/><stop offset="1" stopColor="#6228d7"/></linearGradient></defs></svg>;
const FbIcon = () => <svg width="11" height="11" viewBox="0 0 24 24" fill="#1877f2"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>;

/* ── Helpers ────────────────────────────────────────────── */
const fmtCOP  = (v) => v != null ? new Intl.NumberFormat('es-CO',{style:'currency',currency:'COP',maximumFractionDigits:0}).format(v) : '—';
const fmtNum  = (v) => { if (v == null) return '—'; return v>=1000000?(v/1000000).toFixed(1)+'M':v>=1000?(v/1000).toFixed(1)+'K':String(v); };
const AVATAR_COLORS = ['#6ee7b7','#93c5fd','#fca5a5','#fcd34d','#c4b5fd','#86efac','#fdba74','#67e8f9'];
const initials    = (n) => (n||'?').split(' ').slice(0,2).map(w=>w[0]).join('').toUpperCase();
const avatarColor = (n) => AVATAR_COLORS[(n||'').charCodeAt(0)%AVATAR_COLORS.length];
const typeIcon    = (t) => t==='video'?<IcoVideo/>:t==='carrusel'?<IcoCarousel/>:<IcoImage/>;
const channelIcon = (ch) => ch==='instagram'?<IgIcon/>:ch==='messenger'?<FbIcon/>:<WaIcon/>;
const channelLabel= (ch) => ch==='instagram'?'Instagram':ch==='messenger'?'Messenger':'WhatsApp';

const fmtRel = (ts) => {
  if (!ts) return '';
  try {
    const s = String(ts).replace(' ','T');
    const d = new Date(s.includes('+')||s.includes('Z')?s:s+'-05:00');
    const diff = Math.floor((Date.now()-d.getTime())/60000);
    if (diff < 1) return 'Ahora';
    if (diff < 60) return `${diff}m`;
    const h = Math.floor(diff/60);
    if (h < 24) return `${h}h`;
    if (h < 48) return 'Ayer';
    return d.toLocaleDateString('es-CO',{day:'2-digit',month:'short'});
  } catch { return ''; }
};

const fmtMsgTime = (ts) => {
  if (!ts) return '';
  try {
    const s = String(ts).replace(' ','T');
    const d = new Date(s.includes('+')||s.includes('Z')?s:s+'-05:00');
    return d.toLocaleTimeString('es-CO',{hour:'2-digit',minute:'2-digit'});
  } catch { return ''; }
};

/* ── Component ──────────────────────────────────────────── */
export default function Marketing({ user, onNav, onLogout }) {
  const [activeNav, setActiveNav]         = useState('Marketing');
  const [mkTab, setMkTab]                 = useState('Resumen');
  const [showNotifs, setShowNotifs]       = useState(false);
  const [activePage, setActivePage]       = useState(0);
  const [comments, setComments]           = useState(COMMENTS_INIT);
  const [commentFilter, setCommentFilter] = useState('todos');
  const [replyingTo, setReplyingTo]       = useState(null);
  const [replyText, setReplyText]         = useState('');


  const handleNav = (id) => { setActiveNav(id); if (onNav) onNav(id); };


  const kpi   = KPI_DATA[activePage];
  const chart = CHART_DATA[activePage] || CHART_DATA[0];
  const maxV  = Math.max(...chart.map(d => d.v), 1);
  const posts = POSTS_DATA[activePage] || [];
  const page  = PAGES_DATA[activePage];

  const filteredComments = comments.filter(c => {
    if (commentFilter === 'sin')  return !c.replied;
    if (commentFilter === 'resp') return c.replied;
    return true;
  });

  const sendReply = (id) => {
    if (!replyText.trim()) return;
    setComments(prev => prev.map(c => c.id===id ? {...c, replied:true} : c));
    setReplyingTo(null);
    setReplyText('');
  };

  const isInbox = mkTab === 'Inbox';

  return (
    <>
      <style>{`
        *{box-sizing:border-box;margin:0;padding:0;font-family:'SF Pro Display','SF Pro Text',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;}
        body{overflow:hidden;}
        .app{display:flex;flex-direction:column;flex:1;min-height:0;background:#f0f0ee;}
        .body{display:flex;flex:1;overflow:hidden;}
        .sidebar{width:80px;background:transparent;display:flex;flex-direction:column;justify-content:space-between;align-items:center;padding:20px 0;flex-shrink:0;}
        .sb-island{background:rgba(255,255,255,0.9);backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);border:1px solid rgba(255,255,255,0.4);border-radius:9999px;box-shadow:0 4px 16px rgba(0,0,0,0.07);display:flex;flex-direction:column;align-items:center;gap:2px;padding:10px 10px;}
        .sb-icon-btn{width:42px;height:42px;border-radius:50%;display:flex;align-items:center;justify-content:center;cursor:pointer;border:none;background:transparent;transition:all 0.18s;color:#9CA3AF;flex-shrink:0;}
        .sb-icon-btn:hover{background:rgba(0,0,0,0.05);color:#374151;}
        .sb-icon-btn.active{color:#1f2937;background:rgba(0,0,0,0.07);}
        .sb-dark-circle{width:42px;height:42px;border-radius:50%;background:radial-gradient(circle at 50% 30%,#4B5563,#111827);box-shadow:inset 0 2px 4px rgba(255,255,255,0.12),0 4px 10px rgba(0,0,0,0.32);display:flex;align-items:center;justify-content:center;cursor:pointer;border:none;transition:all 0.18s;flex-shrink:0;}
        .sb-dark-circle:hover{box-shadow:inset 0 2px 4px rgba(255,255,255,0.12),0 6px 16px rgba(0,0,0,0.42);transform:translateY(-1px);}
        .sb-sep{width:22px;height:1px;background:rgba(0,0,0,0.08);margin:3px 0;}
        .main{flex:1;display:flex;flex-direction:column;overflow:hidden;position:relative;}
        .topbar{height:68px;background:transparent;display:flex;align-items:center;padding:0 24px;gap:16px;flex-shrink:0;z-index:10;}
        .tb-brand{display:flex;align-items:center;gap:10px;min-width:120px;}
        .tb-logo{height:32px;display:flex;align-items:center;}
        .tb-nav{flex:1;display:flex;align-items:center;justify-content:center;}
        .tb-nav-inner{display:flex;align-items:center;gap:2px;background:rgba(255,255,255,0.78);backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px);border-radius:999px;border:1px solid rgba(255,255,255,0.65);box-shadow:0 4px 24px rgba(0,0,0,0.08),0 1px 3px rgba(0,0,0,0.05);padding:3px;}
        .tb-nav-item{font-size:13.5px;font-weight:500;color:#555;padding:7px 20px;border-radius:999px;cursor:pointer;transition:all 0.18s;white-space:nowrap;border:none;background:transparent;font-family:inherit;}
        .tb-nav-item:hover{color:#0a0a0a;background:rgba(0,0,0,0.05);}
        .tb-nav-item.active{background:linear-gradient(145deg,#1f1f1f 0%,#0a0a0a 100%);color:#fff;font-weight:700;box-shadow:inset 0 1px 0 rgba(255,255,255,0.12),inset 0 -1px 0 rgba(0,0,0,0.2),0 2px 8px rgba(0,0,0,0.22);}
        .tb-right{display:flex;align-items:center;gap:10px;min-width:150px;justify-content:flex-end;}
        .tb-icon-btn{width:42px;height:42px;border-radius:50%;border:1px solid rgba(255,255,255,0.6);background:rgba(255,255,255,0.7);display:flex;align-items:center;justify-content:center;cursor:pointer;position:relative;transition:background 0.15s;backdrop-filter:blur(8px);}
        .tb-icon-btn:hover{background:rgba(255,255,255,0.9);}
        .tb-badge{position:absolute;top:8px;right:8px;width:7px;height:7px;border-radius:50%;background:#ef4444;border:1.5px solid #fff;}
        .tb-profile{display:flex;align-items:center;gap:9px;background:rgba(255,255,255,0.78);border:1px solid rgba(255,255,255,0.65);backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px);border-radius:999px;padding:5px 14px 5px 5px;cursor:pointer;}
        .tb-profile-img{width:34px;height:34px;border-radius:50%;background:#0a0a0a;overflow:hidden;}
        .tb-profile-name{font-size:13px;font-weight:700;color:#0a0a0a;}
        .tb-profile-role{font-size:11px;color:#999;}

        /* ── Marketing wrap ── */
        .mk-wrap{flex:1;overflow-y:auto;padding:20px 24px 32px;}
        .mk-wrap.inbox-mode{overflow:hidden;padding:0;display:flex;flex-direction:column;}
        .mk-wrap:not(.inbox-mode)::-webkit-scrollbar{width:4px;}
        .mk-wrap:not(.inbox-mode)::-webkit-scrollbar-thumb{background:#e0e0de;border-radius:4px;}

        /* ── Sub-tabs ── */
        .mk-tab-bar{display:flex;gap:2px;background:rgba(255,255,255,0.78);backdrop-filter:blur(10px);border-radius:999px;border:1px solid rgba(255,255,255,0.65);padding:3px;box-shadow:0 4px 24px rgba(0,0,0,0.06);align-self:flex-start;margin-bottom:24px;width:fit-content;}
        .mk-tab{padding:7px 20px;border-radius:999px;font-size:13.5px;font-weight:500;color:#999;cursor:pointer;border:none;background:transparent;transition:all 0.15s;font-family:inherit;white-space:nowrap;}
        .mk-tab.active{background:linear-gradient(145deg,#1f1f1f 0%,#0a0a0a 100%);color:#fff;font-weight:700;box-shadow:inset 0 1px 0 rgba(255,255,255,0.12),0 2px 8px rgba(0,0,0,0.22);}

        /* ── KPI Grid ── */
        .mk-kpi-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:14px;margin-bottom:18px;}
        .mk-kpi-card{background:#fff;border-radius:16px;padding:18px 20px;box-shadow:0 2px 10px rgba(0,0,0,0.05);border:1px solid rgba(0,0,0,0.04);}
        .mk-kpi-icon{width:34px;height:34px;border-radius:10px;display:flex;align-items:center;justify-content:center;margin-bottom:10px;}
        .mk-kpi-label{font-size:12px;color:#999;font-weight:500;margin-bottom:6px;}
        .mk-kpi-val{font-size:26px;font-weight:700;color:#0a0a0a;letter-spacing:-0.6px;margin-bottom:6px;}
        .mk-kpi-delta{display:inline-flex;align-items:center;gap:4px;font-size:12px;font-weight:700;padding:2px 8px;border-radius:999px;}
        .mk-kpi-delta.up{background:#f0fdf4;color:#16a34a;}
        .mk-kpi-delta.down{background:#fef2f2;color:#ef4444;}

        /* ── Chart Card ── */
        .mk-chart-card{background:#fff;border-radius:16px;padding:20px;box-shadow:0 2px 10px rgba(0,0,0,0.05);border:1px solid rgba(0,0,0,0.04);margin-bottom:18px;}
        .mk-chart-hdr{display:flex;justify-content:space-between;align-items:center;margin-bottom:20px;}
        .mk-chart-title{font-size:14px;font-weight:700;color:#0a0a0a;}
        .mk-chart-sub{font-size:12px;color:#bbb;margin-top:2px;}
        .mk-bars{display:flex;gap:8px;align-items:flex-end;height:110px;padding-bottom:4px;}
        .mk-bar-col{flex:1;display:flex;flex-direction:column;align-items:center;gap:5px;height:100%;}
        .mk-bar-track{flex:1;width:100%;display:flex;align-items:flex-end;}
        .mk-bar{width:100%;border-radius:6px 6px 0 0;min-height:4px;transition:height 0.4s;}
        .mk-bar-lbl{font-size:10px;color:#c0c0be;font-weight:500;}
        .mk-bar-val{font-size:10px;color:#888;font-weight:700;}

        /* ── Pages tab ── */
        .mk-pages-nav{display:flex;gap:10px;margin-bottom:20px;flex-wrap:wrap;}
        .mk-page-btn{display:flex;align-items:center;gap:8px;padding:9px 16px;border-radius:12px;border:1.5px solid #e8e8e6;background:#fff;cursor:pointer;transition:all 0.15s;font-size:13px;font-weight:500;color:#555;font-family:inherit;}
        .mk-page-btn.active{border-color:#0a0a0a;background:#0a0a0a;color:#fff;}
        .mk-page-btn:not(.active):hover{border-color:#aaa;}
        .mk-page-dot{width:8px;height:8px;border-radius:50%;flex-shrink:0;}
        .mk-page-fol{font-size:11px;opacity:0.6;margin-left:4px;}

        /* ── Posts ── */
        .mk-posts-grid{display:flex;flex-direction:column;gap:10px;}
        .mk-post-card{background:#fff;border-radius:14px;padding:14px 18px;display:flex;align-items:center;gap:16px;box-shadow:0 1px 6px rgba(0,0,0,0.04);border:1px solid rgba(0,0,0,0.04);transition:box-shadow 0.15s;}
        .mk-post-card:hover{box-shadow:0 4px 16px rgba(0,0,0,0.09);}
        .mk-post-thumb{width:52px;height:52px;border-radius:10px;background:#f0f0ee;display:flex;align-items:center;justify-content:center;flex-shrink:0;}
        .mk-post-body{flex:1;min-width:0;}
        .mk-post-type{font-size:10px;font-weight:700;color:#888;background:#f5f5f5;padding:2px 7px;border-radius:999px;display:inline-block;margin-bottom:4px;}
        .mk-post-caption{font-size:12.5px;color:#333;line-height:1.45;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;}
        .mk-post-date{font-size:11px;color:#bbb;margin-top:3px;}
        .mk-post-stats{display:flex;gap:18px;flex-shrink:0;}
        .mk-pstat{display:flex;flex-direction:column;align-items:center;gap:3px;}
        .mk-pstat-ico{display:flex;align-items:center;justify-content:center;}
        .mk-pstat-val{font-size:14px;font-weight:700;color:#0a0a0a;}
        .mk-pstat-lbl{font-size:10px;color:#bbb;font-weight:500;}

        /* ── Comments ── */
        .mk-cf{display:flex;gap:8px;margin-bottom:20px;}
        .mk-cf-btn{padding:6px 14px;border-radius:999px;font-size:12.5px;font-weight:500;cursor:pointer;border:1px solid #e8e8e6;background:transparent;color:#888;transition:all 0.15s;font-family:inherit;}
        .mk-cf-btn.active{background:#0a0a0a;color:#fff;border-color:#0a0a0a;}
        .mk-comment-card{background:#fff;border-radius:14px;padding:14px 16px;margin-bottom:10px;border:1px solid rgba(0,0,0,0.04);box-shadow:0 1px 6px rgba(0,0,0,0.04);}
        .mk-cm-top{display:flex;gap:10px;align-items:flex-start;}
        .mk-cm-av{width:36px;height:36px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:700;color:#555;flex-shrink:0;}
        .mk-cm-name{font-size:13px;font-weight:700;color:#0a0a0a;}
        .mk-cm-text{font-size:13px;color:#333;line-height:1.5;flex:1;margin-top:1px;}
        .mk-cm-time{font-size:11px;color:#bbb;flex-shrink:0;white-space:nowrap;}
        .mk-cm-actions{display:flex;gap:8px;margin-top:10px;padding-top:10px;border-top:1px solid #f5f5f5;align-items:center;}
        .mk-cm-page{font-size:11px;color:#888;background:#f5f5f5;padding:2px 8px;border-radius:999px;font-weight:500;}
        .mk-cm-btn{padding:5px 12px;border-radius:999px;font-size:12px;font-weight:500;cursor:pointer;transition:all 0.15s;border:1px solid #e8e8e6;background:transparent;color:#555;font-family:inherit;}
        .mk-cm-btn:hover{background:#f5f5f5;}
        .mk-cm-btn.primary{background:#0a0a0a;color:#fff;border-color:#0a0a0a;}
        .mk-cm-btn.primary:hover{background:#333;}
        .mk-replied{display:inline-flex;align-items:center;gap:5px;font-size:11px;font-weight:700;color:#16a34a;background:#f0fdf4;padding:3px 9px;border-radius:999px;}
        .mk-reply-box{display:flex;gap:8px;margin-top:10px;}
        .mk-reply-input{flex:1;padding:8px 12px;border:1.5px solid #e8e8e6;border-radius:10px;font-size:13px;outline:none;font-family:inherit;transition:border-color 0.15s;}
        .mk-reply-input:focus{border-color:#0a0a0a;}
        .mk-reply-send{padding:8px 16px;border-radius:10px;background:#0a0a0a;color:#fff;border:none;font-size:13px;font-weight:700;cursor:pointer;font-family:inherit;transition:background 0.15s;}
        .mk-reply-send:hover{background:#333;}

        /* ── Campaigns ── */
        .mk-camp-grid{display:grid;grid-template-columns:1fr 1fr;gap:14px;}
        .mk-camp-card{background:#fff;border-radius:16px;padding:20px;box-shadow:0 2px 10px rgba(0,0,0,0.05);border:1px solid rgba(0,0,0,0.04);}
        .mk-camp-hdr{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:14px;}
        .mk-camp-name{font-size:14px;font-weight:700;color:#0a0a0a;margin-bottom:3px;}
        .mk-camp-tienda{font-size:11px;color:#999;}
        .mk-camp-status{padding:4px 10px;border-radius:999px;font-size:11px;font-weight:700;}
        .mk-camp-status.activa{background:#f0fdf4;color:#16a34a;}
        .mk-camp-status.pausada{background:#fffbeb;color:#d97706;}
        .mk-camp-status.terminada{background:#f5f5f5;color:#888;}
        .mk-camp-metrics{display:grid;grid-template-columns:repeat(3,1fr);gap:12px;margin-bottom:14px;}
        .mk-camp-metric{display:flex;flex-direction:column;gap:2px;}
        .mk-camp-mlbl{font-size:10px;color:#bbb;font-weight:500;text-transform:uppercase;letter-spacing:0.04em;}
        .mk-camp-mval{font-size:16px;font-weight:700;color:#0a0a0a;letter-spacing:-0.3px;}
        .mk-camp-prog-wrap{background:#f5f5f5;border-radius:999px;height:6px;overflow:hidden;margin-bottom:6px;}
        .mk-camp-prog{height:100%;border-radius:999px;}
        .mk-camp-prog-labels{display:flex;justify-content:space-between;}
        .mk-camp-prog-lbl{font-size:10px;color:#bbb;}

        /* ── Section header ── */
        .mk-section-hdr{display:flex;align-items:baseline;gap:10px;margin-bottom:12px;}
        .mk-section-title{font-size:15px;font-weight:700;color:#0a0a0a;letter-spacing:-0.2px;}
        .mk-section-sub{font-size:12px;color:#bbb;}

      `}</style>

      <div className="app">


        {/* ── BODY ── */}
        <div className="body">

          {/* ── MAIN ── */}
          <div className="main">

            {/* ── PRÓXIMAMENTE OVERLAY ── */}
            <div style={{position:'absolute',inset:0,zIndex:20,background:'rgba(240,240,238,0.92)',backdropFilter:'blur(6px)',WebkitBackdropFilter:'blur(6px)',display:'flex',alignItems:'center',justifyContent:'center'}}>
              <div style={{textAlign:'center',maxWidth:560,padding:'0 24px'}}>
                <div style={{display:'inline-flex',alignItems:'center',gap:8,background:'#0a0a0a',color:'#6ee7b7',borderRadius:999,padding:'6px 18px',fontSize:12,fontWeight:700,letterSpacing:'0.08em',textTransform:'uppercase',marginBottom:28}}>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#6ee7b7" strokeWidth="2.5" strokeLinecap="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                  Próximamente
                </div>
                <div style={{fontSize:32,fontWeight:800,color:'#0a0a0a',letterSpacing:'-0.8px',lineHeight:1.15,marginBottom:12}}>Marketing en Talku</div>
                <div style={{fontSize:15,color:'#888',lineHeight:1.6,marginBottom:40}}>Estamos construyendo un suite completo para gestionar tus redes sociales, campañas y conversaciones desde un solo lugar.</div>
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,textAlign:'left'}}>
                  {[
                    { icon:<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0a0a0a" strokeWidth="1.7" strokeLinecap="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>, title:'Métricas de redes sociales', desc:'Alcance, impresiones y engagement de Instagram y Facebook en tiempo real.' },
                    { icon:<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0a0a0a" strokeWidth="1.7" strokeLinecap="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>, title:'Gestión de comentarios', desc:'Responde comentarios de todas tus páginas desde un inbox unificado.' },
                    { icon:<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0a0a0a" strokeWidth="1.7" strokeLinecap="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/></svg>, title:'Campañas Meta Ads', desc:'Visualiza el rendimiento de tus campañas: CPA, ROAS y presupuesto ejecutado.' },
                    { icon:<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0a0a0a" strokeWidth="1.7" strokeLinecap="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>, title:'Programación de publicaciones', desc:'Crea y agenda posts para Instagram y Facebook directamente desde Talku.' },
                    { icon:<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0a0a0a" strokeWidth="1.7" strokeLinecap="round"><polyline points="22 12 16 12 14 15 10 15 8 12 2 12"/><path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"/></svg>, title:'Social Inbox', desc:'Mensajes de Instagram Direct, Messenger y WhatsApp en una sola bandeja.' },
                    { icon:<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0a0a0a" strokeWidth="1.7" strokeLinecap="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>, title:'Segmentación de audiencias', desc:'Crea audiencias personalizadas basadas en tus clientes de Shopify y WhatsApp.' },
                  ].map(f=>(
                    <div key={f.title} style={{background:'#fff',borderRadius:14,padding:'16px 18px',border:'1px solid rgba(0,0,0,0.05)',boxShadow:'0 2px 8px rgba(0,0,0,0.04)'}}>
                      <div style={{width:36,height:36,borderRadius:10,background:'#f5f5f3',display:'flex',alignItems:'center',justifyContent:'center',marginBottom:10}}>{f.icon}</div>
                      <div style={{fontSize:13,fontWeight:700,color:'#0a0a0a',marginBottom:4}}>{f.title}</div>
                      <div style={{fontSize:12,color:'#999',lineHeight:1.5}}>{f.desc}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className={`mk-wrap${isInbox?' inbox-mode':''}`}>

              {!isInbox && (
                <div className="mk-tab-bar">
                  {MK_TABS.map(t=>(
                    <button key={t} className={`mk-tab${mkTab===t?' active':''}`} onClick={()=>setMkTab(t)}>{t}</button>
                  ))}
                </div>
              )}

              {isInbox && (
                <div style={{padding:'16px 0 10px 16px',flexShrink:0}}>
                  <div className="mk-tab-bar" style={{marginBottom:0}}>
                    {MK_TABS.map(t=>(
                      <button key={t} className={`mk-tab${mkTab===t?' active':''}`} onClick={()=>setMkTab(t)}>{t}</button>
                    ))}
                  </div>
                </div>
              )}

              {/* ════ RESUMEN ════ */}
              {mkTab==='Resumen' && <>
                <div className="mk-kpi-grid">
                  {[
                    { label:'Alcance',        val:fmtNum(kpi.alcance), delta:kpi.alcD, bg:'#f0fdf4', icon:<IcoEye size={17} stroke="#16a34a"/> },
                    { label:'Impresiones',    val:fmtNum(kpi.imp),     delta:kpi.impD, bg:'#eff6ff', icon:<IcoTrend size={17} stroke="#3b82f6"/> },
                    { label:'Engagement',     val:kpi.eng+'%',         delta:kpi.engD, bg:'#fdf4ff', icon:<IcoMsg size={17} stroke="#9333ea"/> },
                    { label:'Nuevos seguid.', val:'+'+fmtNum(kpi.seg), delta:kpi.segD, bg:'#fff7ed', icon:<IcoUsers size={17} stroke="#f97316"/> },
                  ].map(k=>(
                    <div key={k.label} className="mk-kpi-card">
                      <div className="mk-kpi-icon" style={{background:k.bg}}>{k.icon}</div>
                      <div className="mk-kpi-label">{k.label}</div>
                      <div className="mk-kpi-val">{k.val}</div>
                      <span className={`mk-kpi-delta${k.delta>=0?' up':' down'}`}>
                        {k.delta>=0 ? <IcoArrowUp/> : <IcoArrowDn/>}
                        {Math.abs(k.delta)}{typeof k.delta==='number'&&k.label!=='Nuevos seguid.'?'%':''}
                      </span>
                    </div>
                  ))}
                </div>

                <div className="mk-chart-card">
                  <div className="mk-chart-hdr">
                    <div>
                      <div className="mk-chart-title">Alcance diario — últimos 7 días</div>
                      <div className="mk-chart-sub">{page.name}</div>
                    </div>
                    <div style={{display:'flex',gap:8,alignItems:'center'}}>
                      {PAGES_DATA.map((p,i)=>(
                        <button key={p.id} onClick={()=>setActivePage(i)} style={{padding:'4px 12px',borderRadius:999,border:`1.5px solid ${activePage===i?'#0a0a0a':'#e8e8e6'}`,background:activePage===i?'#0a0a0a':'transparent',color:activePage===i?'#fff':'#888',fontSize:12,fontWeight:500,cursor:'pointer',fontFamily:'inherit',transition:'all 0.15s'}}>
                          {p.name.split(' ')[0]}
                        </button>
                      ))}
                    </div>
                  </div>
                  <div className="mk-bars">
                    {chart.map((row,i)=>{
                      const pct = row.v/maxV;
                      const isToday = i===chart.length-1;
                      return (
                        <div key={i} className="mk-bar-col">
                          <div className="mk-bar-val">{fmtNum(row.v)}</div>
                          <div className="mk-bar-track">
                            <div className="mk-bar" style={{height:`${pct*100}%`,background:isToday?'linear-gradient(180deg,#0a0a0a,#333)':'linear-gradient(180deg,#d1d5db,#e5e7eb)'}}/>
                          </div>
                          <div className="mk-bar-lbl" style={{color:isToday?'#0a0a0a':'#c0c0be',fontWeight:isToday?700:500}}>{row.d}</div>
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div className="mk-section-hdr">
                  <div className="mk-section-title">Top Posts</div>
                  <div className="mk-section-sub">Por alcance · {page.name}</div>
                </div>
                <div className="mk-posts-grid">
                  {[...posts].sort((a,b)=>b.reach-a.reach).slice(0,3).map(p=>(
                    <div key={p.id} className="mk-post-card">
                      <div className="mk-post-thumb">{typeIcon(p.type)}</div>
                      <div className="mk-post-body">
                        <div className="mk-post-type">{p.type}</div>
                        <div className="mk-post-caption">{p.caption}</div>
                        <div className="mk-post-date">{p.date}</div>
                      </div>
                      <div className="mk-post-stats">
                        {[
                          {ico:<IcoHeart/>, val:p.likes,         lbl:'Likes'   },
                          {ico:<IcoMsg/>,   val:p.comments,      lbl:'Coment.' },
                          {ico:<IcoEye/>,   val:fmtNum(p.reach), lbl:'Alcance' },
                        ].map(s=>(
                          <div key={s.lbl} className="mk-pstat">
                            <div className="mk-pstat-ico">{s.ico}</div>
                            <div className="mk-pstat-val">{typeof s.val==='number'?fmtNum(s.val):s.val}</div>
                            <div className="mk-pstat-lbl">{s.lbl}</div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </>}

              {/* ════ PÁGINAS ════ */}
              {mkTab==='Páginas' && <>
                <div className="mk-pages-nav">
                  {PAGES_DATA.map((p,i)=>(
                    <button key={p.id} className={`mk-page-btn${activePage===i?' active':''}`} onClick={()=>setActivePage(i)}>
                      <div className="mk-page-dot" style={{background:activePage===i?'#6ee7b7':p.color}}/>
                      {p.name}
                      <span className="mk-page-fol">{fmtNum(p.followers)} seg.</span>
                    </button>
                  ))}
                </div>
                <div className="mk-section-hdr">
                  <div className="mk-section-title">Publicaciones</div>
                  <div className="mk-section-sub">{posts.length} posts</div>
                </div>
                <div className="mk-posts-grid">
                  {posts.map(p=>(
                    <div key={p.id} className="mk-post-card">
                      <div className="mk-post-thumb">{typeIcon(p.type)}</div>
                      <div className="mk-post-body">
                        <div className="mk-post-type">{p.type}</div>
                        <div className="mk-post-caption">{p.caption}</div>
                        <div className="mk-post-date">{p.date}</div>
                      </div>
                      <div className="mk-post-stats">
                        {[
                          {ico:<IcoHeart/>, val:p.likes,    lbl:'Likes'    },
                          {ico:<IcoMsg/>,   val:p.comments, lbl:'Coment.'  },
                          {ico:<IcoEye/>,   val:p.reach,    lbl:'Alcance'  },
                          {ico:<IcoShare/>, val:p.shares,   lbl:'Compart.' },
                        ].map(s=>(
                          <div key={s.lbl} className="mk-pstat">
                            <div className="mk-pstat-ico">{s.ico}</div>
                            <div className="mk-pstat-val">{fmtNum(s.val)}</div>
                            <div className="mk-pstat-lbl">{s.lbl}</div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </>}

              {/* ════ COMENTARIOS ════ */}
              {mkTab==='Comentarios' && <>
                <div className="mk-cf">
                  {[['todos','Todos'],['sin','Sin responder'],['resp','Respondidos']].map(([id,lbl])=>(
                    <button key={id} className={`mk-cf-btn${commentFilter===id?' active':''}`} onClick={()=>setCommentFilter(id)}>{lbl}</button>
                  ))}
                  <span style={{marginLeft:'auto',fontSize:12,color:'#bbb'}}>{filteredComments.length} comentarios</span>
                </div>
                {filteredComments.map(c=>(
                  <div key={c.id} className="mk-comment-card">
                    <div className="mk-cm-top">
                      <div className="mk-cm-av" style={{background:avatarColor(c.author)}}>{initials(c.author)}</div>
                      <div style={{flex:1,minWidth:0}}>
                        <div style={{display:'flex',alignItems:'baseline',gap:6,marginBottom:4}}>
                          <span className="mk-cm-name">{c.author}</span>
                          <span style={{fontSize:11,color:'#bbb'}}>en "{c.post}"</span>
                        </div>
                        <div className="mk-cm-text">{c.text}</div>
                      </div>
                      <div className="mk-cm-time">{c.time}</div>
                    </div>
                    <div className="mk-cm-actions">
                      <span className="mk-cm-page">{c.page}</span>
                      {c.replied
                        ? <span className="mk-replied"><IcoCheck/>Respondido</span>
                        : <button className="mk-cm-btn primary" onClick={()=>setReplyingTo(replyingTo===c.id?null:c.id)}>Responder</button>
                      }
                      <button className="mk-cm-btn" style={{marginLeft:'auto',color:'#ef4444',borderColor:'#fecaca'}} onClick={()=>setComments(prev=>prev.filter(x=>x.id!==c.id))}>Ocultar</button>
                    </div>
                    {replyingTo===c.id && (
                      <div className="mk-reply-box">
                        <input className="mk-reply-input" placeholder={`Responder a ${c.author}...`} value={replyText} onChange={e=>setReplyText(e.target.value)} onKeyDown={e=>e.key==='Enter'&&sendReply(c.id)} autoFocus/>
                        <button className="mk-reply-send" onClick={()=>sendReply(c.id)}>Enviar</button>
                      </div>
                    )}
                  </div>
                ))}
              </>}

              {/* ════ CAMPAÑAS ════ */}
              {mkTab==='Campañas' && <>
                <div className="mk-section-hdr">
                  <div className="mk-section-title">Campañas Meta Ads</div>
                  <div className="mk-section-sub">Estrategia Surf Scaling — ASC</div>
                </div>
                <div className="mk-camp-grid">
                  {CAMPAIGNS_DATA.map(camp=>(
                    <div key={camp.id} className="mk-camp-card">
                      <div className="mk-camp-hdr">
                        <div>
                          <div className="mk-camp-name">{camp.name}</div>
                          <div className="mk-camp-tienda">{camp.tienda}</div>
                        </div>
                        <span className={`mk-camp-status ${camp.status}`}>{camp.status.charAt(0).toUpperCase()+camp.status.slice(1)}</span>
                      </div>
                      <div className="mk-camp-metrics">
                        {[
                          {lbl:'Presupuesto', val:fmtCOP(camp.budget)},
                          {lbl:'Gastado',     val:fmtCOP(camp.spent)},
                          {lbl:camp.metric,   val:fmtNum(camp.results)},
                          {lbl:'CPA',         val:camp.cpa?fmtCOP(camp.cpa):'—'},
                          {lbl:'ROAS',        val:camp.roas?camp.roas+'x':'—', color:camp.roas&&camp.roas>=3?'#16a34a':camp.roas?'#d97706':'#bbb'},
                          {lbl:'Ejecución',   val:camp.pct+'%'},
                        ].map(m=>(
                          <div key={m.lbl} className="mk-camp-metric">
                            <div className="mk-camp-mlbl">{m.lbl}</div>
                            <div className="mk-camp-mval" style={m.color?{color:m.color}:{}}>{m.val}</div>
                          </div>
                        ))}
                      </div>
                      <div className="mk-camp-prog-wrap">
                        <div className="mk-camp-prog" style={{width:camp.pct+'%',background:camp.status==='terminada'?'linear-gradient(90deg,#888,#bbb)':camp.status==='pausada'?'linear-gradient(90deg,#d97706,#fbbf24)':'linear-gradient(90deg,#0a0a0a,#555)'}}/>
                      </div>
                      <div className="mk-camp-prog-labels">
                        <span className="mk-camp-prog-lbl">{fmtCOP(camp.spent)} gastado</span>
                        <span className="mk-camp-prog-lbl">{fmtCOP(camp.budget)} total</span>
                      </div>
                    </div>
                  ))}
                </div>
              </>}

              {/* ════ INBOX ════ */}
              {mkTab==='Inbox' && <SocialInbox user={user}/>}

            </div>
          </div>
        </div>
      </div>
    </>
  );
}
